/* eslint-disable i18next/no-literal-string */
import { cn } from "~/lib/utils";
import { colors } from "~/components/landing/colors";

/**
 * Ported from bouncieweb's `LandingPageComponents/TamperDetectionExample.js`
 * (plus its `WrappedSVGs/DisconnectedIcon`).
 *
 * A mock push notification: red "disconnected" badge, bold headline, and a
 * vehicle / timestamp line separated by a small dot. Font sizes step DOWN at lg
 * and back UP at xlg in the original — reproduced as-is.
 *
 * Original breakpoint map (theme/mediaQueries): lg 1024px -> lg:  xlg 1280px -> xl:
 */

function DisconnectedIcon({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        cx="11"
        cy="11.0664"
        r="10.4027"
        fill="#B70039"
        stroke="#DFE1E5"
        strokeWidth="0.805331"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2643 8.23532C15.7325 7.76716 15.7887 7.06438 15.39 6.6656C14.9912 6.26682 14.2884 6.32306 13.8202 6.79121L11.0007 9.61069L8.18126 6.79121C7.71311 6.32306 7.00746 6.26968 6.60515 6.67199C6.20284 7.0743 6.25622 7.77995 6.72437 8.2481L9.54386 11.0676L6.72449 13.8869C6.25633 14.3551 6.20009 15.0579 6.59887 15.4567C6.99765 15.8554 7.70044 15.7992 8.16859 15.3311L10.988 12.5117L13.8201 15.3438C14.2883 15.812 14.9939 15.8654 15.3962 15.4631C15.7985 15.0607 15.7452 14.3551 15.277 13.8869L12.4449 11.0548L15.2643 8.23532Z"
        fill="white"
      />
    </svg>
  );
}

export default function TamperDetectionExample({
  className,
}: {
  className?: string;
}) {
  return (
    // Notification
    <div
      className={cn(
        "mx-auto flex max-w-[300px] flex-row items-center justify-start gap-3",
        "rounded-[8px] px-3 py-2 shadow-[0_5px_10px_rgba(0,0,0,0.1)]",
        className,
      )}
      style={{ background: "rgba(255, 255, 255, 0.7)" }}
    >
      <div className="w-[22px]">
        <DisconnectedIcon />
      </div>
      {/* Status */}
      <div className="text-left text-[14px] lg:text-[12px] xl:text-[14px]">
        {/* Header */}
        <div className="inline-block font-bold">
          Bouncie has been disconnected
        </div>
        <div className="flex flex-row items-center gap-1">
          {/* Text */}
          <div
            className="text-[12px] [text-wrap:nowrap] lg:text-[10px] xl:text-[12px]"
            style={{ color: colors.grayDark1 }}
          >
            Turo Toyota Camry
          </div>
          {/* Dot */}
          <div
            className="h-[3px] w-[3px] rounded-full"
            style={{ backgroundColor: colors.grayDark1 }}
          />
          <div
            className="text-[12px] [text-wrap:nowrap] lg:text-[10px] xl:text-[12px]"
            style={{ color: colors.grayDark1 }}
          >
            Today at 3:45 AM
          </div>
        </div>
      </div>
    </div>
  );
}
